import {useActions} from "../../../hooks/useActions";
import './Fireworks.css';
import {useTypedSelector} from "../../../hooks/useTypedSelector";
import OpenCard from "./OpenCard";
import {useEffect, useState} from "react";
import {sounds} from "../../../sounds/sound";

function BoxOpenWindow({openBox}: any) {
    const {setOpenBox, setTutorial} = useActions();
    const {tutorial} = useTypedSelector(state => state.auth);

    const [isVisible, setIsVisible] = useState(true);

    useEffect(() => {
        const timer = setTimeout(() => {
            setIsVisible(false);
        }, 5500);

        return () => clearTimeout(timer);
    }, []);

    useEffect(() => {
        const cardsToCheck = [
            openBox?.crafted_card?.card,
            openBox?.rare?.card,
            openBox?.un_1?.card,
            openBox?.un_2?.card,
            openBox?.com_1?.card,
            openBox?.com_2?.card,
            openBox?.com_3?.card,
        ];

        const hasDivineCard = cardsToCheck.some(card => card?.level === 4);

        if (hasDivineCard) {
            sounds.open_box_divine().play();
        } else {
            sounds.open_box().play();
        }
    }, [openBox]);

    return (
        <div>
            {isVisible ? (
                <div className="pyro">
                    <div className="before"></div>
                    <div className="after"></div>
                </div>
            ) : (
                <div></div>
            )}

            <div className={'offerOpenBoxContainer'}>
                <div className={'offerOpenBoxLine'}>
                    {openBox.crafted_card && <OpenCard key="crafted_card" openCard={openBox.crafted_card} />}
                    {openBox.rare && <OpenCard key="openCard_rare" openCard={openBox.rare} />}
                    {openBox.un_1 && <OpenCard key="openCard_un_1" openCard={openBox.un_1} />}
                    {openBox.un_2 && <OpenCard key="openCard_un_2" openCard={openBox.un_2} />}
                    {openBox.com_1 && <OpenCard key="openCard_com_1" openCard={openBox.com_1} />}
                    {openBox.com_2 && <OpenCard key="openCard_com_2" openCard={openBox.com_2} />}
                    {openBox.com_3 && <OpenCard key="openCard_com_3" openCard={openBox.com_3} />}
                </div>

                <div
                    className='offersButtonDone'
                    onClick={() => {
                        setOpenBox(false);

                        if (!tutorial.isActive && tutorial.step === 'ClickShop100') {
                            tutorial.isActive = true;
                            tutorial.step = 'ClickDeck110';
                            setTutorial(tutorial);
                        }
                    }}
                >
                </div>
            </div>
        </div>
    );
}

export default BoxOpenWindow;